import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CdcService {

  CdcRequestItem = new BehaviorSubject<number>(0);

  demanddocumnetid = new BehaviorSubject<number>(0);
  RequsetsItem = new BehaviorSubject<number>(0);
  ExpenseID = new BehaviorSubject<number>(0);

  serials = new BehaviorSubject<any[]>([]);

  constructor(private http: HttpClient) { }
  //Add Items For We Store
  AddItemsForWeStore(data: any) {
    return this.http.post(environment.apiRoot + '/api/AddItemsForWeStore/', data)
  }

  // Get All Items For We Store
  getAllItemsForWeStore() {
    return this.http.get(environment.apiRoot + '/api/CDCAddItemsForWeStore/all')
  }


  //Send Data For We Store
  sendDataForWeStore(model: any) {
    return this.http.post(environment.apiRoot + "/api/CDCAddItemsForWeStore/Add", model)
  }

  // Get Items For Cdc By Id
  getWeSToreItemsByID(Id?: any) {
    return this.http.get(environment.apiRoot + '/api/CDCAddItemsForWeStore/GetById/' +Id)
  }
  //update Cdc We store
  updateFormainWeStore(Model: any) {
    return this.http.put(environment.apiRoot + '/api/CDCAddItemsForWeStore/Update', Model)
  }

  //checkserials

  checkserials(data:{},storeLogId?: number | null){
    return this.http.post(environment.apiRoot + `/api/CDCAddItemsForWeStore/CheckSerialsExistInStore?storeLogId=${storeLogId}`,data)
  }


  //check code for cdc item we store 
  checkExistCodeForWeStore(Id: any, Code: any) {
    let params = new HttpParams();
    if (Id) params = params.append("Id", Id);
    if (Code) params = params.append("Code", Code)
    return new Promise((resolve, reject) => {
      this.http.get(environment.apiRoot + '/api/CDCAddItemsForWeStore/CheckCode', { params }).toPromise()
        .then((res: any) => {
          resolve(!res);
        })
        .catch(error => {
          console.error("Server-side validation error", error);
          reject("Cannot contact validation server");
        });

    });
  }

  // Delete For We Store Items
DeleteForWeStore(id: any) {
  return this.http.delete(
    `${environment.apiRoot}/api/CDCAddItemsForWeStore/Delete`,
    { params: { Id: id } }
  );
}
  //Send Data Of Requsets Item For cdc Company
  sendDataOfRequestsItem(model: any) {
    return this.http.post(environment.apiRoot + '/api/CDCRequestItems/Add', model)
  }
  
  updateDataOfRequestsItem(model: any) {
    return this.http.put(environment.apiRoot + '/api/CDCRequestItems/Update', model)
  }

  // Get Requsets Item By Id For Cdc Company
  getRequestItemById(Id: any) {
    return this.http.get(environment.apiRoot + '/api/CDCRequestItems/GetById/' + Id)
  }
  //Delet Requsets Item For Cdc Company
  deleteRequetsItem() {
    return this.http.delete(environment.apiRoot + '/api/CDCRequestItems/Delete')
  }

  // check serial for main branch is existing or not
  CheckExtistingSerial(Serials: any, BranchId?: any) {
    let params = new HttpParams();
    params = params.append("Serials", Serials);
    if(BranchId) params = params.append("BranchId", BranchId);
    return this.http.get<boolean>(environment.apiRoot + '/api/CDCAddItemsForWeStore/CheckSerialsExistInStore/', { params })
  }

  //check if code exist or not for CDC Requets Item
  CheckExistCodeForRequsetsItem(Id: any, Code: any) {
    let params = new HttpParams();
    params = params.append("Id", Id);
    params = params.append("Code", Code);
    return new Promise((resolve, reject) => {
      this.http.get(environment.apiRoot + '/api/CDCRequestItems/CheckCode/', { params }).toPromise()
        .then((res: any) => {
          resolve(!res);
        })
        .catch(error => {
          console.error("Server-side validation error", error);
          reject("Cannot contact validation server");
        });

    });
  }
  //Get Serial From Specific Branch
  getSerialFromSpecificBarnch() {
    return this.http.get(environment.apiRoot + '/api/Branch/GetDropDown')
  }

  //Approved or Reject for all requsets Item
  doApprovedOrReject(Model: any) {
    return this.http.post(environment.apiRoot + '/api/CDCItemsActions/Add', Model)
  }

  //Get DropDownMenu for Reject or Approved
  dropDownForRejOrApproved() {
    return this.http.get(environment.apiRoot + '/api/CDCItemsActions/GetDropDown/Action')
  }

  //Get All Requsets That Rejected Or Approved depend on previous api
  getAllRequsetsThatRejOrApproved(Action: any, BranchId: any, DateFrom: any, DateTo: any) {
    let params = new HttpParams();
    params = params.append("Action", Action);
    params = params.append("BranchId", BranchId);
    params = params.append("DateFrom", DateFrom);
    params = params.append("DateTo", DateTo)
    return this.http.get(environment.apiRoot + '/api/CDCItemsActions/all', { params })
  }


  //Get DropDown Menu For Invoces 
  getMenuForInvoces(id?: number) {
    return this.http.get(`${environment.apiRoot}/api/Demands/GetDropDown/Documents?id=${id}`);
  }

  // cdcStatistcs 

  getCdcStatistics () {
    return this.http.get(`${environment.apiRoot}/api/CDCStatistics/GetAllStatistics`)
  }

  verifySendedSerials (data:any) {
    return this.http.post(`${environment.apiRoot}/api/CDCAddItemsForWeStore/VerifySerials`, data)
  }

  updateDepositeFromBranchRequest (data :any) {
    return this.http.put(`${environment.apiRoot}/api/DepositeFromBranchRequest/Updateaccept`, data)
  }
  getStatusDropDown () {
    return this.http.get(`${environment.apiRoot}/api/DepositeFromBranchRequest/branshrequeststatus`)
  }
  getExpenseStatusDropDown () {
    return this.http.get(`${environment.apiRoot}/api/Expenses/GetDropDown/ExpenseStatus`)
  }
  getInvoiceStatusDropDown () {
    return this.http.get(`${environment.apiRoot}/api/Expenses/GetDropDown/InvoiceStatus`)
  }
  getInvoicetypeDropDown () {
    return this.http.get(`${environment.apiRoot}/api/Expenses/GetDropDown/InvoiceType`)
  }
  getlastcode () {
    return this.http.get(`${environment.apiRoot}/api/CDCAddItemsForWeStore/GetLastcode`)
  }
  updateExpenseStatus(data:any){
    return this.http.put(`${environment.apiRoot}/api/Expenses/UpdateExpenseStatus`, data)
  }

  //get Branch By ID
  getBranchID(id:any) {
    return this.http.get(`${environment.apiRoot}/api/Branch/GetById/`, id)
  }


  getInvoiceTypeDropDown () {
    return this.http.get(`${environment.apiRoot}/api/CdcExpense/GetDropDown/InvoiceType`,)
    
  }

  getInvoiceStausDropDown () {
    return this.http.get(`${environment.apiRoot}/api/CdcExpense/GetDropDown/InvoiceStatus`,)
    
  }


  //demands 

  getalldemands() {
    return this.http.get(environment.apiRoot + '/api/Demands/all')
  }
  
  getallcdcItems() {
    return this.http.get(`${environment.apiRoot}/api/CdcItems/all`)
  }

  getalldemandmessage(id?:number) {
    return this.http.get(`${environment.apiRoot}/api/DemandMessages/GetDropDown?id=${id}`);
  }
  

  getdemanddocumentByID(Id?: any) {
    return this.http.get(environment.apiRoot + '/api/Demands/GetById/' +Id)
    
  }


  //distributeprofit 

  getallprofitdistribute() {
    return this.http.get(environment.apiRoot + '/api/ProfitDistribute/all')
  }

  addprofit(data:{}){
    return this.http.post(environment.apiRoot + `/api/ProfitDistribute/Add`,data)
  }

//uplaod Attachment in add-cdc-expense component
uploaddPhoto(data: FormData) {
  return this.http.post(environment.apiRoot + `/api/CdcExpense/UploadAttachment`, data);
}

DeleteDemandMaster(id: any) {
  return this.http.delete(`${environment.apiRoot}/api/Demands/Delete?DocumentId=${id}`)

  
}

AddMobileSales(data: any) {
  return this.http.post(environment.apiRoot + '/api/CdcSales/CreateAddMobileSheet', data)
}

AddCashSales(data: any) {
  return this.http.post(environment.apiRoot + '/api/CdcSales/CreateAddCashSheet', data)
}

AddAdslSales(data: any) {
  return this.http.post(environment.apiRoot + '/api/CdcSales/CreateAddAdslSheet', data)
}

}
